export default __webpack_public_path__ + "static/media/output.d97bcd36.mp3";